import React, {useEffect, useState} from "react";
import {Modal} from "@cjdev-internal/visual-stack-x/Modal";
import {Button} from "@cjdev-internal/visual-stack-x/Button";
import {Row} from "@cjdev-internal/visual-stack-x/Row";
import * as appConstant from "../../constants/appConstant";
import {useApolloClient, useMutation} from "@apollo/client";
import {GET_PLACEMENT_DATA, REMOVE_PLACEMENT_MUTATION} from "../../constants/graphql-query-mutation";
import "./styles/RemoveRecordModal.css";

const RemoveRecordModal = ({closeModal, openAlert, closeAlert, placementRecord}) => {
    const [isRemovingPlacement, setIsRemovingPlacement] = useState(false);
    const [deletePlacement, {data, loading}] = useMutation(REMOVE_PLACEMENT_MUTATION)

    const client = useApolloClient();

    const removeHandler = () => {
        deletePlacement({
            variables: {placementId: parseInt(placementRecord.id)}
        })
    }

    const alertProps = {closeType: "icon", onClose: closeAlert}

    useEffect(() => {
        setIsRemovingPlacement(loading);
        if (data) {
            const {message, id} = data.deletePlacement;
            if (message.includes(appConstant.CREATE_MODAL_SUCCESS_MESSAGE_TO_COMPARE)) {
                const alertMessage = `${id}${appConstant.HYPHEN}${placementRecord.placementname} has been removed successfully.`
                openAlert({...alertProps, type: "success", children: alertMessage})
                closeModal();
                //ToDo: Check the Timeout Scenario in testcase
                setTimeout(closeAlert, 5000);
                client.refetchQueries({
                    include: [GET_PLACEMENT_DATA],
                });
            } else if (message.includes(appConstant.CREATE_MODAL_ERROR_MESSAGE_TO_COMPARE)) {
                openAlert({...alertProps, type: "warning", children: message})
            }
        }
    }, [loading])

    const removeModalProps = {
        headerTitle:
            <div className='header-rm'>
                {appConstant.REMOVE_RECORD_TITLE}
            </div>,
        footer:
            <Row gap="medium">
                <Button id='cancel-button-rm' type='tertiary' onClick={closeModal}>{appConstant.CANCEL}</Button>
                <Button id='remove-button-rm' type='primary' onClick={removeHandler}
                        disabled={isRemovingPlacement}>{appConstant.REMOVE}</Button>
            </Row>,
        height: "202px",
        minHeight: "202px"
    }

    return (
        <Modal id="removeModal" {...removeModalProps}>
            <div>{appConstant.REMOVE_MODAL_MESSAGE}</div>
            <p className={"placement-details"}>{placementRecord.id}{appConstant.HYPHEN}{placementRecord.placementname}</p>
        </Modal>
    )
}

export default RemoveRecordModal;